import { useParams, useSearchParams } from "react-router-dom";
import {
  useGetLumiProducts,
  useGetMappedUnmappedChowdeckProducts,
  useGetStoreMappingDetails,
} from "../../../../hooks/api/queries/useMarketPlace";
import { ChowdeckProductLink } from "./ChowdeckProductLink";
import { ChowdeckStoreConnect } from "./ChowdeckStoreConnect";
import styles from "./styles.module.scss";
import secondaryComponents from "../..";
import { convertToTilteCase } from "../../../../helpers";

export const ChowdeckMappingForm = ({
  title = "",
  description = "",
  providerKey = "chowdeck",
  isEditMode = false,
}) => {
  const { connection_id } = useParams();
  const [search] = useSearchParams();

  const {
    data: mappedUnmappedProducts,
    isLoading: isLoadingMappedUnmappedProducts,
  } = useGetMappedUnmappedChowdeckProducts({
    queryParams: {
      connection_id: connection_id,
      store_mapping_id: search.get("mapping_id"),
    },
    isEnabled: connection_id && search.get("mapping_id") ? true : false,
  });

  const { data: lumiProductList, isLoading: isLoadingLumiProduct } =
    useGetLumiProducts({
      queryParams: {
        connection_id: connection_id,
        lumi_store_id: search.get("lumi_store_id"),
      },
      isEnabled: connection_id && search.get("lumi_store_id") ? true : false,
    });

  const { data: storeMappingDetails, isLoading: isLoadingStoreDetails } =
    useGetStoreMappingDetails({
      id: search.get("mapping_id"),
      queryParams: {
        connection_id: connection_id,
      },
      isEnabled: connection_id && search.get("mapping_id") ? true : false,
    });

  return (
    <div className={styles.mapContainer}>
      <header className={styles.header}>
        <h5>{title}</h5>
        <p>{description}</p>
      </header>
      <hr style={{ margin: 0 }} />

      <div className={styles.contentContainer}>
        <div>
          <div className={styles.selectStoreHeading}>
            <div className={styles.badge}>
              <span>Step 1</span> of 2
            </div>
            <div className={styles.shortLine} />
            <h6 className="mb-0">
              Link items between your selected Lumi Business Store &{" "}
              {convertToTilteCase(providerKey)}
              Store
            </h6>
          </div>

          <secondaryComponents.LoaderHelper
            isLoading={isLoadingMappedUnmappedProducts && isEditMode}
            classNames={"mt-5"}
          >
            <ChowdeckStoreConnect
              isEditMode={isEditMode}
              providerKey={providerKey}
              lumi_store_name={mappedUnmappedProducts?.lumi_store_name}
              chowdeck_store_name={
                mappedUnmappedProducts?.marketplace_store_name
              }
            />
          </secondaryComponents.LoaderHelper>
        </div>

        <div>
          <div className={`${styles.selectStoreHeading} align-items-start`}>
            <div className="d-flex align-items-center" style={{ gap: "5px" }}>
              <div className={styles.badge}>
                <span>Step 2</span> of 2
              </div>
              <div className={styles.shortLine} />
            </div>
            <div>
              <h6>
                Link items between your selected Lumi Business Store &{" "}
                {convertToTilteCase(providerKey)} Store
              </h6>
              <p>
                Linking your items from {convertToTilteCase(providerKey)} to
                Lumi Business matches their product IDs so the two platforms can
                work together.
                <br /> Don&apos;t worry—your products in Lumi Business will stay
                safe and won&apos;t be affected during the process.
              </p>
            </div>
          </div>

          <secondaryComponents.LoaderHelper
            isLoading={
              isLoadingMappedUnmappedProducts ||
              isLoadingLumiProduct ||
              isLoadingStoreDetails
            }
            classNames={"mt-5"}
          >
            {mappedUnmappedProducts ? (
              <ChowdeckProductLink
                mappedUnmappedProducts={mappedUnmappedProducts}
                lumiProductList={lumiProductList}
                providerKey={providerKey}
                isEditMode={isEditMode}
                storeMappingDetails={storeMappingDetails}
              />
            ) : (
              <h6 className="my-4">Complete step 1 to continue with step 2</h6>
            )}
          </secondaryComponents.LoaderHelper>
        </div>
      </div>
    </div>
  );
};
